import { z } from "zod"

export const powurOsAdderPriceSchema = z.object({
  id: z.number().int(),
  start: z.string(),
  end: z.nullable(z.string()),
  cost: z.number(),
  isVariable: z.boolean(),
  isRequired: z.boolean(),
  adderId: z.number().int(),
  adderRegionId: z.number().int(),
  companyId: z.nullable(z.number().int()),
  createdUserName: z.nullable(z.string()),
  modifiedUserName: z.nullable(z.string()),
  createdDateTime: z.nullable(z.string()),
  modifiedDateTime: z.nullable(z.string()),
})
export type PowurOsAdderPrice = z.infer<typeof powurOsAdderPriceSchema>
